import { render, staticRenderFns } from "./TotalInsurableValueBoundQuotator.vue?vue&type=template&id=25f07bf4&scoped=true&"
import script from "./TotalInsurableValueBoundQuotator.vue?vue&type=script&lang=js&"
export * from "./TotalInsurableValueBoundQuotator.vue?vue&type=script&lang=js&"
import style0 from "./TotalInsurableValueBoundQuotator.vue?vue&type=style&index=0&id=25f07bf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f07bf4",
  null
  
)

export default component.exports